import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import { Icon } from './Icon';
import { Popover } from './Popover';
import { IconButton } from './Button';
import s from './Popover.module.css';

export interface MenuItem {
  label: ReactNode;
  icon?: string;
  onSelect: () => void;
  danger?: boolean;
  disabled?: boolean;
  checked?: boolean;
}

export type MenuEntry = MenuItem | 'divider' | { heading: string };

export function MenuList({ items, close }: { items: MenuEntry[]; close: () => void }) {
  return (
    <div role="menu">
      {items.map((item, i) => {
        if (item === 'divider') return <div key={i} className={s.menuDivider} />;
        if ('heading' in item) return <div key={i} className={s.menuLabel}>{item.heading}</div>;
        return (
          <button
            key={i}
            role="menuitem"
            type="button"
            disabled={item.disabled}
            className={cx(s.menuItem, item.danger && s.danger)}
            onClick={() => {
              close();
              item.onSelect();
            }}
          >
            {item.icon && <Icon name={item.icon} size={18} />}
            {item.label}
            {item.checked && <Icon name="check" size={18} className={s.check} />}
          </button>
        );
      })}
    </div>
  );
}

/** The "⋯" overflow menu. */
export function MoreMenu({ items, label = 'More actions' }: { items: MenuEntry[]; label?: string }) {
  return (
    <Popover
      align="end"
      width={220}
      trigger={(p) => <IconButton icon="more_horiz" label={label} outlined {...p} />}
    >
      {(close) => <MenuList items={items} close={close} />}
    </Popover>
  );
}
